export type ProjectScale =
  | '0-1k'
  | '1k-10k'
  | '10k-100k'
  | '100k-1M'
  | '1M+'
  | 'others';

/**
 * Buckets a count into its order-of-magnitude {@link ProjectScale}.
 *
 * @param count - The raw count (runs, keys, steps, ...)
 * @returns The bucket label to add to the RUM view attributes
 */
export function projectScaleBucket(count: number): ProjectScale {
  if (!Number.isFinite(count) || count < 0) {
    return 'others';
  }
  if (count < 1_000) {
    return '0-1k';
  }
  if (count < 10_000) {
    return '1k-10k';
  }
  if (count < 100_000) {
    return '10k-100k';
  }
  if (count < 1_000_000) {
    return '100k-1M';
  }
  return '1M+';
}
